// @ts-nocheck
import React, { useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useAuthentication from 'utils/useAuthentication';

import Login from 'pages/Login';
import LoadingDimmer from 'components/LoadingDimmer';

import { getUser } from 'actions/auth';
import { updated } from 'store/slices/auth';

const shouldBypassAuthForE2E = process.env.REACT_APP_E2E_BYPASS_AUTH === 'true';

const e2eMockUser = {
    userId: 'advisor-1',
    firstName: 'Test',
    lastName: 'Advisor',
    email: 'advisor@example.com',
    organisations: [
        {
            organisationId: 'test-org',
            name: 'Test Organisation',
            ready: true,
        },
    ],
};

const AuthGuard = () => {
    const { authenticated, initialized } = useAuthentication();
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const isFetchingUser = useSelector(state => state.apiCalls.loading['auth.getUser']);

    useEffect(() => {
        if (shouldBypassAuthForE2E) {
            if (!user) {
                dispatch(updated({ user: e2eMockUser }));
            }
            return;
        }

        if (!initialized || !authenticated || user || isFetchingUser) return;
        dispatch(getUser());
    }, [authenticated, dispatch, initialized, isFetchingUser, user]);

    if (shouldBypassAuthForE2E) {
        if (!user) return <LoadingDimmer />;
        return <><Outlet/></>;
    }

    if (!initialized) return <LoadingDimmer />;
    if (!authenticated) return <Login />;
    if (!user) return <LoadingDimmer />;

    return <><Outlet/></>;
};

AuthGuard.propTypes = {};

export default AuthGuard;
